<div class="template">
  <h4 class="text-uppercase vertical-align-middle mt-2">{{ filterValue }}</h4>
  <div class="device-info">
    <div class="row">
      <div>
        <h4 class="m-0 mt-3 ml-4 app-color-1 vertical-align-middle">
          <strong>
            <span class="material-icons app-color-dark link-cursor" (click)="hideView()">arrow_back</span>
          </strong>
          &nbsp;
          <strong class="app-color-dark">{{'Device Detail - EP History' | translate}}</strong>
        </h4>
      </div>
    </div>
    <div class="row ml-2 mr-3">
      <hr class="col-md-12">
    </div>
    <div class="table-responsive">
      <table class="table table-striped history-table" matSortDisableClear matSort matSortActive="severity"
        matSortDirection="asc" (matSortChange)="sortDevicesByHistory($event)">
        <thead>
          <tr>
            <th scope="col" mat-sort-header="endPoint.Name">{{'Endpoint' | translate}}</th>
            <th scope="col" mat-sort-header="sensor.Name">{{'Site / Dept' | translate}}</th>
            <th scope="col" mat-sort-header="startDate">{{'Start Date' | translate}}</th>
            <th scope="col" mat-sort-header="endDate">{{'End Date' | translate}}</th>
            <th scope="col" class="duration-cell">{{'Duration' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          @for (device of sensorsHistory; track trackById($index, device)) {
            <tr [class.active-assignment]="device.isActive">
              <td class="name-cell">
                <h6 class="details-text">{{ device?.endPointName }}</h6>
              </td>
              <td class="name-cell">
                <h6 class="details-text">{{ device?.sensorName }}</h6>
              </td>
              <td>
                <h6 class="details-text">{{ $safeNavigationMigration(device?.startDate) | dateFormat : dateFormatService.userDateWithTimeFormat }}</h6>
              </td>
              <td>
                @if (device.isActive) {
                  <span class="badge-present">{{'Present' | translate}}</span>
                } @else {
                  <h6 class="details-text">{{ $safeNavigationMigration(device?.endDate) | dateFormat : dateFormatService.userDateWithTimeFormat }}</h6>
                }
              </td>
              <td class="duration-cell">
                <h6 class="details-text">{{ device.durationText }}</h6>
              </td>
            </tr>
          }
          @if (!sensorsHistory || sensorsHistory.length === 0) {
            <tr>
              <td colspan="5" class="no-data-available with-padding">{{'No Device History Found' | translate}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>